import { IJobFieldSettings } from 'wisestep-api';
import { WsSelect, WsSelectObj } from 'wisestep-base';

import { useJobSettingsContext } from '../../../context/jobsListContext';
import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const HiringForTypeFilter = ({ name, title = 'Hiring For' }: WsFilterProps) => {
  const jobSettings: IJobFieldSettings = useJobSettingsContext();
  const hiringForList: WsSelectObj[] = jobSettings.hiringFor?.availableFields.map(
    (dropDownItem: string) => ({
      label: dropDownItem,
      value: dropDownItem,
    })
  );

  return (
    <WsAccordion title={title}>
      <WsSelect name={name} selectArray={hiringForList} placeholder="Select" />
    </WsAccordion>
  );
};

export default HiringForTypeFilter;
